/**
 * User inactivity timeout configuration
 *
 * With 1-minute check intervals, users will be logged out between:
 * - Minimum: 28.5 minutes (if inactive right before a check)
 * - Maximum: 29.5 minutes (if inactive right after a check)
 */
export const DEFAULT_INACTIVITY_TIME = 28.5 * 60 * 1000 // 28.5 minutes
export const DEFAULT_DEBOUNCE_DELAY = 1000 // 1 second debounce
export const DEFAULT_CHECK_INACTIVITY_DELAY = 1 * 60 * 1000 // 1 minute debounce
export const DEFAULT_EVENTS: (keyof WindowEventMap)[] = [
  'keydown',
  'pointermove',
]
